import {WatchQueryFetchPolicy} from '@apollo/client'
import {MutationFetchPolicy} from '@apollo/client/core/watchQueryOptions'

type globalConstantsType_ = {
  networkOnly: WatchQueryFetchPolicy
  networkOnlyMutation: MutationFetchPolicy
  invalidPhoneNumber: string
  phoneNumberShouldNotExceedTen: string
  specialCharactersNotAllowed: string
  apiContentTypejson: string
  previewSettings: {isFluidWidth: boolean; width: number; height: number}
  filterBooleanValue: {
    true: string
    false: string
  }
  scriptType: {
    electric: string
    gas: string
    dual: string
  }
  tpvType: {
    outboundLiveAgent: string
    ivr: string
    smsTpv: string
    liveAgent: string
  }
}
export const GLOBAL_CONSTANTS: globalConstantsType_ = {
  networkOnly: 'network-only',
  networkOnlyMutation: 'network-only',
  invalidPhoneNumber: 'Invalid Phone number',
  phoneNumberShouldNotExceedTen: "Phone number shouldn't exceed 10 digits",
  specialCharactersNotAllowed: 'Special characters not allowed',
  apiContentTypejson: 'application/json',
  previewSettings: {isFluidWidth: true, width: 500, height: 500},
  filterBooleanValue: {
    true: 'TRUE',
    false: 'FALSE',
  },
  scriptType: {
    electric: 'Electric',
    gas: 'Gas',
    dual: 'Dual',
  },
  tpvType: {
    outboundLiveAgent: 'OUTBOUND LIVE AGENT',
    ivr: 'IVR',
    smsTpv: 'SMS TPV',
    liveAgent: 'LIVE AGENT',
  },
}
